import { signOut } from 'aws-amplify/auth';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserMenu = ({ isAuthenticated, sandboxSignInUrl, lab, onOpenLabAccess }) => {
  const navigate = useNavigate();
  const { authenticateUser } = useAuth();

  async function handleSignOut() {
    try {
      await signOut();
      authenticateUser(false, '', '');
      localStorage.setItem('isAuthenticated', false);
      navigate('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  // The sign-in details open in a dialog rather than expanding here. The menu is a
  // narrow strip that closes on an outside click, and these are values a student reads
  // and copies while AWS is open in another tab - see LabAccessDialog.
  const hasSandbox = Boolean(lab?.signInUrl || sandboxSignInUrl);

  return (
    <>
      {isAuthenticated ? (
        <>
          <a className="user-menu-item" href="/preferences">
            Preferences
          </a>
          <a className="user-menu-item" href="/certificates">
            My certificates
          </a>
          {hasSandbox && onOpenLabAccess && (
            <button type="button" className="user-menu-item" onClick={onOpenLabAccess}>
              AWS Sandbox
            </button>
          )}
          <button onClick={handleSignOut} className="user-menu-item">
            Sign out
          </button>
        </>
      ) : (
        <a className="user-menu-item" href="/signin">
          Sign in
        </a>
      )}
    </>
  );
};

export default UserMenu;
